module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    on: {
      "click": _vm.getDetail
    }
  }, [_c('div', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.message.type))]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.message.title))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("datetime")(_vm.message.dt_create)))]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._v(_vm._s(_vm.body))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aeea43be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Message.vue
// module id = 98
// module chunks = 0